<template>
  <v-main v-if="loading || error">
    <app-loading :visible="loading"></app-loading>
    <div v-if="error" class="text-center ma-5">
      Não foi possivel carregar o comprovante
    </div>
  </v-main>
  <div v-else class="document">
    <document-header :account="sender.name" description="Comprovante<br>de Transferência"></document-header>
    <div class="container">
      <div class="row row-wrap">
        <div class="col-6">
          <div class="item-box">
            <div class="item-box-header"><h4>Conta debitada</h4></div>
            <div class="item-box-content">
              <div class="row">
                <!-- <div class="col">
                  <h5>CPF/CNPJ</h5>
                  {{ sender.document | document }}
                </div> -->
                <div class="col">
                  <h5>Conta Heppi</h5>
                  {{ sender.heppiAccount }}
                </div>
              </div>
              <h5>Nome</h5>
              {{ sender.name }}
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="item-box">
            <div class="item-box-header"><h4>Favorecido</h4></div>
            <div class="item-box-content">
              <div class="row">
                <div class="col">
                  <h5>CPF/CNPJ</h5>
                  {{ receiver.document | document }}
                </div>
                <div class="col">
                  <h5>Conta Heppi</h5>
                  {{ receiver.heppiAccount }}
                </div>
              </div>
              <h5>Nome</h5>
              {{ receiver.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="item-box mt-4">
        <div class="item-box-header"><h3>Detalhes da Transferência</h3></div>
        <div class="item-box-content">
          <div class="row">
            <div class="col-auto pa-5">
              <div class="amount">
                {{ amount | priceInteger }}<small>,{{ amount | priceCents }}</small>
              </div>
            </div>
            <div class="col-auto pa-5 text-uppercase">
              <h5>Realizado em</h5>
              <div class="text-bold">
                {{ date | moment('DD MMM YYYY') }}
              </div>
            </div>
            <div class="col pa-5">
              <h5>Finalidade</h5>
              {{ description }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import AppLoading from '@/components/Loading'
import documentHeader from '@/components/documentHeader'
import { mapGetters } from 'vuex'

export default {
  name: 'transfer',
  components: {
    AppLoading,
    documentHeader
  },
  data () {
    return {
      loading: false,
      error: false,
      sender: {
        name: '',
        heppiAccount: '',
        document: ''
      },
      receiver: {
        name: '',
        heppiAccount: '',
        document: ''
      },
      amount: 0,
      date: '2022-09-26',
      description: ''
    }
  },
  computed: {
    ...mapGetters(['transactionById']),
    transactionId () {
      return (this.$route.query && this.$route.query.id) || null
    },
    transactionData () {
      return this.transactionId ? this.transactionById(this.transactionId) : null
    }
  },
  async created () {
    if (this.transactionData) {
      this.loading = true
      try {
        // sender
        const senderId = this.transactionData.sender ? this.transactionData.sender.id : this.transactionData.account_id
        const sender = await axios.get('accounts/' + senderId + '?api_key=' + senderId, { baseURL: 'https://payment-gateway-api.heppi.io/api/' })
        if (sender.data) {
          this.sender = {
            name: sender.data.name.indexOf('(') > 0 ? sender.data.name.substring(0, sender.data.name.indexOf('(')) : sender.data.name,
            heppiAccount: sender.data.account_number,
            document: sender.data.owner.document
          }
        } else {
          this.error = true
        }
        // receiver
        const receiverId = this.transactionData.receiver ? this.transactionData.receiver.id : this.transactionData.account_id
        const receiver = await axios.get('accounts/' + receiverId + '?api_key=' + receiverId, { baseURL: 'https://payment-gateway-api.heppi.io/api/' })
        if (receiver.data) {
          this.receiver = {
            name: receiver.data.name.indexOf('(') > 0 ? receiver.data.name.substring(0, receiver.data.name.indexOf('(')) : receiver.data.name,
            heppiAccount: receiver.data.account_number,
            document: receiver.data.owner.document
          }
        } else {
          this.error = true
        }
      } catch (error) {
        this.error = true
      }
      this.amount = this.transactionData.amount
      this.date = this.$moment(this.transactionData.payment_date.$date, 'YYYY-MM-DD[T]HH:mm[.000Z]').subtract(3, 'hours').format('YYYY-MM-DD HH:mm')
      this.description = this.transactionData.description
      this.loading = false
    }
    document.title = this.sender.name + ' - ' + this.receiver.name + ' - transferencia - ' + this.$moment(this.date).format('DD-MM-YYYY')
  }
}
</script>
